import { ZonedDateTime } from "@js-joda/core"
import { BloodGlucoseFormContext, BloodGlucoseFormContextApiDto } from "./BloodGlucoseFormContext"
import { QuickCheckReason, QuickCheckReasonApiDto } from "./QuickCheckReason"

export const medicationTakenAnswers = ["YES", "NO"] as const
export type MedicationTakenApiDto = (typeof medicationTakenAnswers)[number]
export type MedicationTaken = MedicationTakenApiDto

export type MedicationLogApiDto = {
  medicationTaken: MedicationTakenApiDto
  note?: string | null
}
export type MedicationLog = MedicationLogApiDto

export const toMedicationLog = (
  medicationTaken: MedicationTaken | null,
  note: string
): MedicationLogApiDto | null => (medicationTaken ? { medicationTaken, note: note || null } : null)

export type BloodGlucoseFormApiDto = {
  id: string
  patientId: string
  context: BloodGlucoseFormContextApiDto
  dateTime: string // ISO 8601 with offset
  carbsInGrams: number | null
  proteinInGrams: number | null
  mealContents: string | null
  medications: MedicationLogApiDto | null
  notes: string | null
  reasons: QuickCheckReasonApiDto[] | null
  readingId: string | null
  editable: boolean
}

export type BloodGlucoseForm = {
  id: string
  patientId: string
  context: BloodGlucoseFormContext
  dateTime: ZonedDateTime
  carbsInGrams: number | null
  proteinInGrams: number | null
  mealContents: string | null
  medications: MedicationLog | null
  notes: string | null
  reasons: QuickCheckReason[] | null
  readingId: string | null
  editable: boolean
}

export const toBloodGlucoseForm = (dto: BloodGlucoseFormApiDto): BloodGlucoseForm => ({
  id: dto.id,
  patientId: dto.patientId,
  context: dto.context,
  dateTime: ZonedDateTime.parse(dto.dateTime),
  carbsInGrams: dto.carbsInGrams,
  proteinInGrams: dto.proteinInGrams,
  mealContents: dto.mealContents,
  medications: dto.medications,
  notes: dto.notes,
  reasons: dto.reasons,
  readingId: dto.readingId,
  editable: dto.editable,
})
